import { render } from "./SelectCompany.vue?vue&type=template&id=f9aa5d2e&ts=true"
import script from "./SelectCompany.vue?vue&type=script&lang=ts"
export * from "./SelectCompany.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__